import { useEffect, useState } from 'react';
import { apiRequests } from '../../../shared/api/apiRequests';
import { formatImageUrl } from '../../../shared/utils/formatImageUrl';
import { Link } from 'react-router-dom';
import { Delete } from '../../../features/DeleteEntity/index.js';

export const Product = ({ data, deleteHandler }) => {
  const [image, setImage] = useState('');

  const encodeImageUrl = (url) => {
    try {
      const urlParts = url.split(/(\/\/[^\/]+)/);
      if (urlParts.length >= 3) {
        const encodedPath = urlParts[2]
          .split('/')
          .map((segment) =>
            segment.includes('.')
              ? segment
                  .split('.')
                  .map((part) => encodeURIComponent(part))
                  .join('.')
              : encodeURIComponent(segment),
          )
          .join('/');
        return urlParts[0] + urlParts[1] + encodedPath;
      }
      return encodeURI(url);
    } catch (error) {
      console.error('Error encoding URL:', error);
      return url;
    }
  };

  useEffect(() => {
    if (data.mainImage && data.mainImage.imgPath) {
      console.log('Image path found:', data.mainImage.imgPath);
      try {
        let imageUrl = data.mainImage.imgPath;

        if (imageUrl.startsWith('/uploads/')) {
          imageUrl = `${import.meta.env.VITE_API_URL}${imageUrl}`;
          console.log('Converted to absolute URL:', imageUrl);
        }

        const encodedUrl = encodeImageUrl(imageUrl);
        console.log('Encoded image URL:', encodedUrl);

        setImage(encodedUrl);

        const img = new Image();
        img.onload = () => {
          console.log('Image loaded successfully');
        };
        img.onerror = () => {
          console.log('Error loading image, using fallback');
          setImage('/placeholder.png');
        };
        img.src = encodedUrl;
      } catch (error) {
        console.error('Error setting image URL:', error);
        setImage('/placeholder.png');
      }
    } else {
      console.log('No image path found in data:', data);
      setImage('/placeholder.png');
    }
  }, [data]);

  const handleDelete = async () => {
    await apiRequests.products.delete(data.id).then(() => deleteHandler(data.id));
  };

  return (
    <div className="col-md-3 mb-3">
      <div className="goods-item">
        <div className="goods-image" style={{ backgroundImage: `url(${formatImageUrl(image)})` }}>
          <div className="remote">
            <div className="actions">
              <a href={`/shop/products/${data.id}/modifiers`}>
                <i className="bi bi-collection"></i>
              </a>
              <Link to={`${window.location.pathname}/${data.id}`} className={'action edit'}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.204 10.796L19 9C19.5453 8.45475 19.8179 8.18213 19.9636 7.88803C20.2409 7.32848 20.2409 6.67152 19.9636 6.11197C19.8179 5.81788 19.5453 5.54525 19 5C18.4548 4.45475 18.1821 4.18213 17.888 4.03639C17.3285 3.75911 16.6715 3.75911 16.112 4.03639C15.8179 4.18213 15.5453 4.45475 15 5L13.1814 6.81866C14.1452 8.46926 15.5314 9.84482 17.204 10.796ZM11.7269 8.27311L4.8564 15.1436C4.43134 15.5687 4.21881 15.7812 4.07907 16.0423C3.93934 16.3034 3.88039 16.5981 3.7625 17.1876L3.1471 20.2646C3.08058 20.5972 3.04732 20.7635 3.14193 20.8581C3.23654 20.9527 3.40284 20.9194 3.73545 20.8529L6.81243 20.2375C7.40189 20.1196 7.69661 20.0607 7.95771 19.9209C8.21881 19.7812 8.43134 19.5687 8.8564 19.1436L15.7458 12.2542C14.1241 11.2386 12.7524 9.87627 11.7269 8.27311Z"
                    fill="#198754"
                  />
                </svg>
              </Link>
              <button className="action remove">
                <Delete onConfirm={() => handleDelete()} />
              </button>
            </div>
          </div>
        </div>
        <div className="goods-content">
          <div className="name">{data.title}</div>
          <div className="goods-desc">
            <div className="categories">{data.category?.title}</div>
            <div className="cost">{data.basePricing != null ? `${data.basePricing} $` : ''}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
